module.exports = __webpack_public_path__ + "static/media/northProduct.3e435b27.jpg";